import PropTypes from "prop-types";
import { useQueryString } from "hooks";

const Pagination = ({ pagination }) => {
	const { updateQuery } = useQueryString();

	const {
		hasNextPage,
		hasPrevPage,
		page: currentPage,
		totalPages,
	} = pagination;

	// Handle page change
	const handlePageChange = (page) => {
		if (page < 1 || page > totalPages || page === currentPage) return;
		updateQuery({ page }, undefined, () => {
			window.scrollTo(0, 0);
		});
	};

	// Generate page numbers to display
	const getPageNumbers = () => {
		const pages = [];
		const maxPagesToShow = 5; // Number of pages to show in the pagination
		let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
		let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

		if (endPage - startPage + 1 < maxPagesToShow) {
			startPage = Math.max(1, endPage - maxPagesToShow + 1);
		}

		for (let i = startPage; i <= endPage; i++) {
			pages.push(i);
		}

		return pages;
	};

	return (
		<div className={`flex items-center justify-center gap-2 my-4 flex-wrap ${pagination?.totalDocs > 10 ? "block" : "hidden"}`}>
			{/* Previous Button */}
			<button
				onClick={() => handlePageChange(currentPage - 1)}
				disabled={!hasPrevPage}
				className="px-3 py-1 sm:px-4 sm:py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
			>
				السابق
			</button>

			{/* Page Numbers - Hidden on small screens */}
			<div className="hidden sm:flex gap-2">
				{getPageNumbers().map((page) => (
					<button
						key={page}
						onClick={() => handlePageChange(page)}
						className={`px-3 py-1 sm:px-4 sm:py-2 border rounded-lg text-sm sm:text-base ${currentPage === page ? "bg-primary-button text-white" : "bg-white"
							}`}
					>
						{page}
					</button>
				))}
			</div>

			{/* Next Button */}
			<button
				onClick={() => handlePageChange(currentPage + 1)}
				disabled={!hasNextPage}
				className="px-3 py-1 sm:px-4 sm:py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
			>
				التالي
			</button>

			{/* Display Current Page and Total Pages */}
			<span className="ml-2 sm:ml-4 text-sm sm:text-base">
				الصفحة {currentPage} من {totalPages}
			</span>
		</div>
	);
};

// PropTypes
Pagination.propTypes = {
	pagination: PropTypes.shape({
		hasNextPage: PropTypes.bool.isRequired,
		hasPrevPage: PropTypes.bool.isRequired,
		limit: PropTypes.number.isRequired,
		nextPage: PropTypes.number,
		page: PropTypes.number.isRequired,
		pagingCounter: PropTypes.number.isRequired,
		prevPage: PropTypes.number,
		totalDocs: PropTypes.number.isRequired,
		totalPages: PropTypes.number.isRequired,
	}).isRequired,
};

export default Pagination;